export const renewalEsTranslation = {
  renewal: {
    steps: {
      choose: "Elegir",
      term: "Plazo del contrato",
      next: "Siguientes pasos",
      moveOut: "Aviso de desocupación",
      of: "Paso {{current}} de {{total}}",
      back: "Atrás",
      continue: "Continuar",
      ntvSummary: "Hogar",
      ntvDetails: "Detalles del aviso",
      ntvConfirm: "Confirmar",
    },
    choice: {
      title: "Renovar o mudarse",
      subtitle: "¿Va a renovar o a mudarse?",
      renew: "Renovar el contrato",
      renewDescription: "Quédese en su hogar y elija un nuevo plazo.",
      moveOut: "Enviar aviso de desocupación",
      moveOutDescription:
        "Indíquenos su fecha de mudanza y los siguientes pasos.",
    },
    stub: {
      renewTitle: "Renovar el contrato",
      renewBody:
        "La selección de plazo y la firma llegarán pronto. Por ahora, vuelva al inicio o use la solicitud de renovación de su propiedad si ya tiene instrucciones.",
      moveOutTitle: "Aviso de desocupación",
      moveOutBody:
        "El aviso de desocupación en autoservicio llegará pronto. Comuníquese con el equipo de la propiedad si necesita dar aviso hoy.",
      backHome: "Volver al inicio",
    },
    terms: {
      title: "Elija un plazo de contrato",
      subtitle: "Revise los plazos y tarifas de renovación aprobados.",
      rentOnlyNote:
        "Los montos mostrados son solo la renta mensual. Otros cargos recurrentes no se incluyen en esta comparación.",
      months_one: "{{count}} mes",
      months_other: "{{count}} meses",
      months: "{{count}} meses",
      termLabel_one: "Contrato de {{count}} mes",
      termLabel_other: "Contrato de {{count}} meses",
      termLabel: "Contrato de {{count}} meses",
      colTerm: "Seleccionar plazo",
      colRent: "Renta",
      colDates: "Fechas del contrato",
      perMonth: "/ mes",
      preferred: "Preferido",
      saving: "Guardando…",
      saveError: "No pudimos guardar su plazo. Inténtelo de nuevo.",
      continue: "Continuar",
      empty:
        "Aún no hay plazos de renovación disponibles para su contrato. Comuníquese con el equipo de la propiedad.",
      nextTitle: "Plazo seleccionado",
      nextBody:
        "Su plazo quedó guardado. La actualización de datos del hogar y la firma de la renovación vienen a continuación.",
    },
    ntv: {
      summaryTitle: "Revise su hogar",
      summarySubtitle:
        "Ya tenemos estos datos de su contrato. Continúe para ingresar el aviso de desocupación.",
      leavingLabel: "En este contrato",
      propertyLabel: "Propiedad",
      unitLabel: "Unidad",
      leaseEndLabel: "Fin del contrato",
      detailsTitle: "Aviso de desocupación",
      detailsSubtitle:
        "Indíquenos cuándo se muda y a dónde debemos enviar la correspondencia final.",
      moveOutDate: "Fecha deseada de mudanza",
      noticeHint: "Debe ser al menos {{days}} días a partir de hoy.",
      allLeaving: "¿Se mudan todos los residentes?",
      allLeavingYes: "Sí",
      allLeavingNo: "No",
      whoMoving: "¿Quiénes se mudan?",
      whoMovingHint:
        "Seleccione a todos los que se van. Deje sin marcar a quienes se quedan.",
      reason: "Motivo de la mudanza",
      reasonPlaceholder: "Seleccione un motivo",
      forwarding: "Dirección de reenvío",
      forwardingHint: "Obligatoria para los estados de cuenta finales.",
      forwardingPlaceholder: "Calle, ciudad, estado, código postal",
      reviewTitle: "Confirme su aviso",
      reviewSubtitle: "Revise estos datos antes de enviar.",
      submit: "Enviar aviso",
      submitting: "Enviando…",
      successTitle: "Aviso enviado",
      successBody:
        "Se notificó al equipo de la propiedad. Actualizarán su contrato. No necesita hacer nada más aquí.",
      errorGeneric:
        "No pudimos enviar su aviso. Intente de nuevo o comuníquese con la propiedad.",
      errTooSoon: "Elija una fecha con al menos {{days}} días a partir de hoy.",
      errBlackout:
        "Esa fecha no está disponible para mudanza en esta propiedad. Elija otro día.",
      errInvalidDate: "Ingrese una fecha de mudanza válida.",
      errWhoRequired: "Seleccione al menos un residente que se muda.",
      errWhoAll: "Si todos se mudan, elija Sí arriba.",
      errReason: "Seleccione un motivo de mudanza.",
      errForwarding: "Ingrese una dirección de reenvío.",
      errReasonsEmpty:
        "Los motivos no están disponibles ahora. Intente más tarde o comuníquese con la propiedad.",
    },
    banner: {
      selfServiceLink: "Comenzar",
    },
    homeStatus: {
      ntvTitle: "Lamentamos que se vaya. Se muda el {{moveOutDate}}.",
      ntvSecondary:
        "Se notificó al equipo de la propiedad. No necesita hacer nada más aquí.",
      renewTitle:
        "Está renovando — plazo de {{months}} meses a {{rent}}/mes ({{dateRange}}).",
      renewContinue: "Continuar",
      renewChangeTerm: "Cambiar plazo",
    },
  },
};
